// import ICMWrapper from "@/app/components/icm-wrapper";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { BULLION_PRODUCT } from "@/app/alts/bullion/type-constants";
import { DigitalGoldFeatures, DigitalSilverFeatures } from "@/app/constants/bullion-features";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

type WhyICMGoldProps = {
    activeBullion: string;
    showDownloadAppBtn?: boolean;
    handleDownloadAppClick: () => void;
};

const WhyICMGold = ({ activeBullion, showDownloadAppBtn, handleDownloadAppClick }: WhyICMGoldProps) => {
    const [investmentFeatures, setInvestmentFeatures] = useState(DigitalGoldFeatures);

    useEffect(() => {
        // This effect can be used to perform any side effects when the active bullion changes

        if (activeBullion === BULLION_PRODUCT.GOLD.TYPE) {
            setInvestmentFeatures(DigitalGoldFeatures);
        } else if (activeBullion === BULLION_PRODUCT.SILVER.TYPE) {
            setInvestmentFeatures(DigitalSilverFeatures);
        }
    }, [activeBullion]);

    return (
        <div
            id="section-why-icm-gold"
            className="sec-why-gold flex flex-col items-center justify-center pb-s11 md:pb-s20 md:pt-s17"
        >
            <h2
                id="section-title"
                className="px-3 text-center text-3xl font-semibold leading-[130%] tracking-[-0.48px] md:mb-[72px] md:mt-s15 md:px-0 md:text-6xl md:leading-[120%]"
            >
                {activeBullion === BULLION_PRODUCT.GOLD.TYPE
                    ? "Why Choose InCred Money for Digital Gold?"
                    : activeBullion === BULLION_PRODUCT.SILVER.TYPE
                      ? "Why Invest in Digital Silver with InCred Money?"
                      : ""}
            </h2>

            <div
                id="block-container"
                className="mb-s10 mt-s11 grid grid-cols-1 gap-8 md:mb-s16 md:mt-0 md:grid-cols-3 md:grid-rows-2 md:gap-[58px]"
            >
                {investmentFeatures.map((feature, index) => {
                    return (
                        <div
                            id={"block-" + (index + 1)}
                            className="flex flex-col items-center justify-start"
                            key={index}
                        >
                            <div className="mb-s11 flex h-auto w-[72px] items-center justify-center rounded-full md:h-[72px]">
                                <Image
                                    id="block-img"
                                    src={feature?.icon ?? ""}
                                    alt="gold-icon"
                                    width={72}
                                    height={72}
                                />
                            </div>
                            <h2
                                id="block-title"
                                className="mb-2 text-center text-base text-xl font-semibold leading-[130%] tracking-[-0.48px]"
                            >
                                {feature.title}
                            </h2>
                            <p
                                id="block-info"
                                className="max-w-[335px] text-center text-sm font-normal leading-[130%] tracking-[0.14px] text-neutral-500 md:leading-[160%]"
                            >
                                {feature.description}
                            </p>
                        </div>
                    );
                })}
            </div>

            {showDownloadAppBtn ? (
                <div className="hidden flex-col items-center justify-center gap-4 md:flex md:flex-row">
                    <RegularButton
                        id="btn-download-app"
                        variant={ButtonVariant.PrimaryDefault}
                        label="Download the app"
                        size={ButtonSize.Large}
                        noIcon={true}
                        showRightIcon={false}
                        className="hidden md:flex"
                        onClick={handleDownloadAppClick}
                    />
                </div>
            ) : null}
        </div>
    );
};
export default WhyICMGold;
